import {
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation, useQueryClient} from '@github-ui/react-query'
import {threadPreviewsQueryKey} from '../page-data/payloads/thread-previews'
import {useMarkersActions} from '../stores/selectors'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {FilesRoutePayload} from '../page-data/payloads/files'
import type {FileKey, LineKey} from '@github-ui/diff-lines/types'
import {pullRequestDismissAutomatedReviewCommentPath} from '@github-ui/paths'

export function useDismissAutomatedReviewThreadMutation(filePath: string, lineMarkersKey: LineKey | FileKey) {
  const {
    pullRequest: {pathName: basePath},
    user: {currentUserLogin},
  } = useRoutePayload<FilesRoutePayload>()
  const queryClient = useQueryClient()
  const {updateThread} = useMarkersActions()

  return useMutation({
    mutationFn: async ({
      automatedReviewCommentId,
      reason,
    }: {
      automatedReviewCommentId: string
      reason: string
      threadId: string
    }) => {
      const apiUrl = pullRequestDismissAutomatedReviewCommentPath({basePath, automatedReviewCommentId})
      const response = await fetchWithErrorHandling(apiUrl, {method: 'PUT', body: {reason}})

      throwErrorsIfBadResponse(response)
    },
    onSuccess: (_data, variables) => {
      updateThread(Number(variables.threadId), filePath, lineMarkersKey, oldThread => {
        if (oldThread?.commentsData?.comments[0]?.automatedComment) {
          const automatedComment = oldThread.commentsData?.comments[0]?.automatedComment
          return {
            ...oldThread,
            isResolved: true,
            resolvedBy: currentUserLogin,
            commentsData: {
              ...oldThread.commentsData,
              comments: [
                {
                  ...oldThread.commentsData.comments[0],
                  automatedComment: {...automatedComment, isDismissed: true},
                },
                ...oldThread.commentsData.comments.slice(1),
              ],
            },
          }
        }
      })

      // invalidate pullRequestFilesToolbar queries
      queryClient.invalidateQueries({
        queryKey: threadPreviewsQueryKey(basePath),
      })
    },
  })
}
